// Every host this app is served from, and the backend that host talks to.
// This map is the definition — nothing infers a backend from a country prefix
// or from the current hostname. Adding a deployment means adding a line here.
export const API_HOST_BY_FE_HOST = {
  'eg.customer.paymob.com': 'accept.paymob.com',
  'uae.customer.paymob.com': 'uae.paymob.com',
  'ksa.customer.paymob.com': 'ksa.paymob.com',
  'om.customer.paymob.com': 'oman.paymob.com',
  'alpha.customer.paymob.com': 'accept-alpha.paymob.com',
  'beta.customer.paymob.com': 'uat-uae.paymob.com',
} as const;

// Local development and any host not listed above (preview builds) talk to the
// alpha backend — never to a production one. getAPIURLByDomain warns when a
// production build ends up here, since that means a deployment is missing from
// the map.
export const FALLBACK_API_HOST =
  API_HOST_BY_FE_HOST['alpha.customer.paymob.com'];
